import { Box, CircularProgress, Container, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useOfferById } from "../../services/offersService";
import { OfferReadOnlyView } from "./OfferDialogs/OfferReadOnlyView";

export const OfferReadOnlyWindowPage = () => {
    const { offerId } = useParams();
    const { t } = useTranslation();
    const { data: offer, isLoading, isError } = useOfferById(offerId);

    if (isLoading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <CircularProgress />
            </Box>
        );
    }

    if (isError || !offer) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="100vh">
                <Typography variant="h6" color="error">
                    {t("offers.OfferReadOnlyWindowPage.error")}
                </Typography>
            </Box>
        );
    }

    return (
        <Container maxWidth="xl" sx={{ py: 4 }}>
            <Typography variant="h4" gutterBottom>
                {t("offers.OfferReadOnlyWindowPage.title")}
            </Typography>
            <OfferReadOnlyView offer={offer} />
        </Container>
    );
};
